import { render, staticRenderFns } from "./TeachTableSelector.vue?vue&type=template&id=5bd91a2a&scoped=true"
import script from "./TeachTableSelector.vue?vue&type=script&lang=js"
export * from "./TeachTableSelector.vue?vue&type=script&lang=js"
import style0 from "./TeachTableSelector.vue?vue&type=style&index=0&id=5bd91a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd91a2a",
  null
  
)

export default component.exports